<template>
  <modal :title="titleName" :show="showModal" @close="closeModal()">
    <div class="content txt-center" slot="content">
      <p style="padding-bottom:10px">
        Temos uma nova versão disponível. Clique abaixo para atualizar o sistema e ter acesso as
        novidades!
      </p>
    </div>
    <div class="action flex center" slot="action">
      <div class="buttons center">
        <a
          @click="acceptModal()"
          class="button primary medium"
          :class="{ unusual: unusual == 'accept' }"
        >
          Atualizar
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal";

export default {
  name: "modal-new-version",
  props: {
    titleName: {
      required: false,
      default: "Nova Versão Disponível"
    },
    show: {
      required: true,
      default: false
    },
    unusual: {
      required: false,
      default: "false"
    }
  },
  components: {
    Modal
  },
  data() {
    return {
      showModal: false,
      seenGuide: {}
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    }
  },
  mounted() {},
  methods: {
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", true);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px;
  }
}
</style>
